import React from 'react';

import makeStyles from '@mui/styles/makeStyles';

export type ImageDimensionsType = [number, number];
export type ImageProps = {
  alt?: string;
  className?: string;
  dimensions?: ImageDimensionsType;
  isInOverflowContainer?: boolean;
  src: string;
};

const useStyles = ([width, height, isPNG]) =>
  makeStyles({
    aspectRatioBox: {
      height: 0,
      overflow: 'hidden',
      paddingTop: `${(height / width) * 100}%`,
      position: 'relative',
      animation: isPNG
        ? undefined
        : '$skeletonLoading 1s linear infinite alternate',
    },
    aspectRatioBoxInside: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    image: {
      width: '100%',
      height: 'auto',
      color: 'hsl(200, 20%, 90%)',
    },
    '@keyframes skeletonLoading': {
      '0%': {
        backgroundColor: 'hsl(200, 20%, 80%)',
      },
      '100%': {
        backgroundColor: 'hsl(200, 20%, 95%)',
      },
    },
  })();

export function Image(props: ImageProps): JSX.Element {
  const { alt = '', className = '', dimensions = [112, 112], src } = props;
  const isPNG = src.includes('.png');
  const classes = useStyles([...dimensions, isPNG]);

  const [width, height] = dimensions;
  const source = `${src}?auto=format&auto=compress&fit=crop&w=${width}&h=${height}`;

  return (
    <div className={className}>
      <div className={classes.aspectRatioBox} data-fd="image-holder">
        <div className={classes.aspectRatioBoxInside}>
          <img
            alt={alt}
            aria-label={alt}
            className={classes.image}
            height={height}
            loading="lazy"
            src={source}
            srcSet={`${source}&dpr=1 1x, ${source}&dpr=2 2x, ${source}&dpr=3 3x`}
            width={width}
          />
        </div>
      </div>
    </div>
  );
}
